import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ObscuredTabType } from 'estensa-module';

import { ObscuredData, ObscuredDataModalConfiguration } from './obscured-data.models';

@Component({
    selector: 'se-obscured-data',
    templateUrl: './obscured-data.component.html',
    styleUrls: ['./obscured-data.component.scss'],
})
export class ObscuredDataComponent {
    customVisibility = this.data.customVisibility;
    images = this.data.images;
    readonly = this.data.readonly ?? false;
    obscuredData = { ...this.data.data };
    suggestions = this.data.suggestions;
    type = this.data.type;
    showTooltipConfidentiality = false;
    showTooltipObscuring = false;
    constructor(
        @Inject(MAT_DIALOG_DATA) private data: ObscuredDataModalConfiguration,
        public dialogRef: MatDialogRef<ObscuredDataComponent, ObscuredData>,
    ) {}

    get hasSpecialLaws() {
        return this.type === ObscuredTabType.CustomVisibility || this.type === ObscuredTabType.FSE20;
    }

    get isDisabled() {
        // In caso di FSE2.0, i pulsanti non sono mai disabilitati.
        return this.readonly && this.type !== ObscuredTabType.FSE20;
    }

    get showSaveButton() {
        return this.readonly && this.type === ObscuredTabType.FSE20;
    }
}
